// EmailChangeComponent.jsx
import React, { useState } from 'react';
import { Form, Button, Table, Card, Alert, Spinner, Row, Col } from 'react-bootstrap';
import { emailService } from './emailService';

const returnOneEmail = (applications)=>{

  if(!applications) return '';

  const uniq_emails = {};

  applications.forEach(a=>{
    if(!uniq_emails[a.email]) uniq_emails[a.email] = 0;
    uniq_emails[a.email] += 1;
  });


  const countEmails = Object.keys(uniq_emails);

  if (countEmails.length == 1) return countEmails[0];

  return '';

}

const EmailChangeComponent = () => {
  const [currentEmail, setCurrentEmail] = useState('');
  const [targetEmail, setTargetEmail] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [applications, setApplications] = useState([]);
  
  // Состояния для UI
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  // Поиск заявок по текущему email
  const handleSearch = async (e) => {
    e.preventDefault();
    if (!currentEmail) return;

    setIsLoading(true);
    setError(null);
    setSuccessMessage(null);
    setApplications([]);

    try {
      const result = await emailService.getApplicationsByEmail(currentEmail);
      
      const data = result.data;
      
      setApplications(data || []);

      setTargetEmail(returnOneEmail(data || []));

      if (data.length === 0) {
        setError('Заявок за цим email не знайдено.');
      }
    } catch (err) {
      setError('Помилка при завантаженні заявок. Спробуйте пізніше.');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  // Изменение email для найденных заявок
  const handleUpdateEmail = async (e) => {
    e.preventDefault();
    if (!targetEmail || !newEmail) return;

    setIsUpdating(true);
    setError(null);
    setSuccessMessage(null);

    try {
      await emailService.updateApplicationsEmail(targetEmail, newEmail);
      setSuccessMessage('Email успішно змінено для всіх знайдених заявок!');
      // Очищаем форму и таблицу после успешного обновления
      setNewEmail('');
      setApplications([]);
      setCurrentEmail('');
    } catch (err) {
      setError('Помилка при зміні email. Спробуйте знову.');
      console.error(err);
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <Card className="shadow-sm m-3">
      <Card.Header as="h5" className="bg-primary text-white">
        Зміна електронної пошти в заявках
      </Card.Header>
      <Card.Body>
        
        {/* Системные уведомления */}
        {error && <Alert variant="danger">{error}</Alert>}
        {successMessage && <Alert variant="success">{successMessage}</Alert>}

        {/* Форма 1: Поиск заявок */}
        <Form onSubmit={handleSearch} className="mb-4">
          <Row className="align-items-end">
            <Col md={8}>
              <Form.Group controlId="currentEmail">
                <Form.Label>Знайти</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="example@mail.com або номер свідоцтва"
                  value={currentEmail}
                  onChange={(e) => setCurrentEmail(e.target.value.trim())}
                  required
                  disabled={isLoading || isUpdating}
                />
              </Form.Group>
            </Col>
            <Col md={4} className="mt-2 mt-md-0">
              <Button 
                variant="primary" 
                type="submit" 
                className="w-100"
                disabled={isLoading || isUpdating}
              >
                {isLoading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Пошук...
                  </>
                ) : (
                  'Знайти заявки'
                )}
              </Button>
            </Col>
          </Row>
        </Form>

        {!targetEmail && applications.length > 0 && 
                    <div style={{padding: "10px", marginTop: "10px", marginBottom: "10px"}}>

                       <Form.Label className="fw-bold">В знайдених заявках різні електронні пошти.</Form.Label>

                    </div>

}

                    {/* Форма 2: Ввод нового email (показывается только если заявки найдены) */}
            {!!targetEmail && 
            <div style={{marginTop: "10px", marginBottom: "10px"}}><Form onSubmit={handleUpdateEmail} className="mt-4 p-3 bg-light rounded border">
              <Row className="align-items-end">
                <Col md={8}>
                  <Form.Group controlId="newEmail">
                    <Form.Label className="fw-bold">Нова електронна пошта</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="new-example@mail.com"
                      value={newEmail}
                      onChange={(e) => setNewEmail(e.target.value)}
                      required
                      disabled={isUpdating}
                    />
                  </Form.Group>
                </Col>
                <Col md={4} className="mt-2 mt-md-0">
                  <Button 
                    variant="success" 
                    type="submit" 
                    className="w-100"
                    disabled={isUpdating || !newEmail}
                  >
                    {isUpdating ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Змінюю...
                      </>
                    ) : (
                      'Змінити адреси'
                    )}
                  </Button>
                </Col>
              </Row>
            </Form>
            </div>
            }


        {/* Таблица с результатами поиска */}
        {applications.length > 0 && (
          <div className="mb-4">
            <h6 className="mb-3">Знайдені заявки:</h6>
            <div className="table-responsive">
              <Table striped bordered hover size="sm">
                <thead className="table-light">
                  <tr>
                    {true && <th>№</th>}
                    {true && <th>Номер заявки</th>}
                    <th>Дата заявки</th>
                    <th>Ім'я дитини</th>
                    <th>Свідоцтво про народження</th>
                    {true && <th>Контактний телефон</th>}
                    {true && <th>Пошта</th>}
                  </tr>
                </thead>
                <tbody>
                  {applications.map((app, i) => (
                    <tr key={app.id || app.number}>
                      {true &&<td>{i+1}</td>}
                      {true &&<td>{app.number}</td>}
                      <td>{app.date && new Date(app.date).toLocaleDateString()}</td>
                      <td>{app.childName}</td>
                      <td>{app.birthCertificate}</td>
                      {true && <td>{app.phone}</td>}
                      {true && <td>{app.email}</td>}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

          </div>
        )}

      </Card.Body>
    </Card>
  );
};

export default EmailChangeComponent;
